module.exports = __webpack_public_path__ + "img/agent2.40500004.png";